import '../../../../styles/screens/client-visit-details/manage-module/HotelList.css';
import { RechargeStringLabels } from '../../../../util/Strings';
import HotelListTable from './HotelListTable';
import ModuleHeader from '../../../common-components/ModuleHeader';
import { useSelector } from 'react-redux';
import { useState } from 'react';

function HotelList() {
  const data = useSelector((state) => state.hotel.hotelList);
  const isVisitCompleted = useSelector(
    (state) => state.visits.selectedVisitIsCompleted
  );

  const [showOrderModal, setShowOrderModal] = useState(false);

  return (
    <div className="events-list-container">
      <ModuleHeader
        heading={RechargeStringLabels.recharge}
        buttons={[
          {
            label: "Update Order",
            onClick: () => setShowOrderModal(true),
            show: data && data.length > 0 && !isVisitCompleted,
          },
        ]}
      />
      <div className="events-list-content">
        <HotelListTable
          showOrderModal={showOrderModal}
          setShowOrderModal={setShowOrderModal}
        />
      </div>
    </div>
  );
}

export default HotelList;